
export class FormAccessListKey {

    private accessValue: string;
    private internalId: string;
    private turnFormInternalId: string;

    constructor(accessValue?: string, internalId?: string, turnFormInternalId?: string) {
        this.accessValue = accessValue;
        this.internalId = internalId;
        this.turnFormInternalId = turnFormInternalId;
    }

    public get AccessValue() {
        return this.accessValue;
    }
    public set AccessValue(accessValue) {
        this.accessValue = accessValue;
    }

    public get InternalId() {
        return this.internalId;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public get TurnFormInternalId() {
        return this.turnFormInternalId;
    }
    public set TurnFormInternalId(turnFormInternalId) {
        this.turnFormInternalId = turnFormInternalId;
    }
}

